import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface TestSearchProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
}

const TestSearch: React.FC<TestSearchProps> = ({ searchTerm, onSearchChange }) => {
  return (
    <div className="relative">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        type="search"
        placeholder="Search tests by name or description..."
        className="pl-8 w-full"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
  );
};

export default TestSearch; 